import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { AppComponent } from 'src/app/app.component';
import { ChannelResponse } from '../../models';

@Component({
    selector: 'app-channel-header',
    templateUrl: './channel-header.component.html',
    styleUrls: ['./channel-header.component.scss']
})
export class ChannelHeaderComponent implements OnInit, AfterViewInit {

    @Input() channel: ChannelResponse;
    @Input() showBadge: boolean = true;

    get routerLink(): string[] {
        if (this.channel.seasonId !== undefined) {
            return ['/season', this.channel.seasonId.toString()];
        }
        return ['/shows', this.channel.slug]
    }

    image: any;

    constructor(private app: AppComponent) {
    }

    ngOnInit(): void {
        this.image = this.channel.images?.find(i => i.type === 'badge')?.url;
    }

	ngAfterViewInit(): void {
		 
	}
}
